import { CheckCircle2, Info } from "lucide-react"; // Pastikan install lucide-react atau ganti dengan icon lain

export const listKetentuan = [
  {
    color:
      "bg-indigo-50 border-indigo-200 text-indigo-900 dark:bg-indigo-900/20 dark:border-indigo-800/50 dark:text-indigo-100",
    iconColor: "text-indigo-600 dark:text-indigo-400",
    jumlahPilihan: "1 Pilihan",
    ketentuan: "Bebas memilih di program apapun.",
    alternatifs: [
      "1 Diploma Tiga (D3)",
      "1 Diploma Empat (D4) / Sarjana Terapan",
      "1 Sarjana",
    ],
  },
  {
    color:
      "bg-emerald-50 border-emerald-200 text-emerald-900 dark:bg-emerald-900/20 dark:border-emerald-800/50 dark:text-emerald-100",
    iconColor: "text-emerald-600 dark:text-emerald-400",
    jumlahPilihan: "2 Pilihan",
    ketentuan: "Bebas memilih di program apapun.",
    alternatifs: [
      "2 Diploma Tiga",
      "2 Diploma Empat/Sarjana Terapan",
      "2 Sarjana",
      "1 Diploma Tiga & 1 Sarjana",
      "1 Diploma Empat/Sarjana Terapan & 1 Sarjana",
    ],
  },
  {
    color:
      "bg-amber-50 border-amber-200 text-amber-900 dark:bg-amber-900/20 dark:border-amber-800/50 dark:text-amber-100",
    iconColor: "text-amber-600 dark:text-amber-400",
    jumlahPilihan: "3 Pilihan",
    ketentuan:
      "2 Program Akademik dan 1 Vokasi, ATAU 1 Program Akademik dan 2 Vokasi.",
    alternatifs: [
      "2 Diploma Tiga & 1 Sarjana",
      "2 Diploma Empat/Sarjana Terapan & 1 Sarjana",
      "2 Sarjana & 1 Diploma Tiga",
      "2 Sarjana & 1 Diploma Empat/Sarjana Terapan",
    ],
  },
  {
    color:
      "bg-rose-50 border-rose-200 text-rose-900 dark:bg-rose-900/20 dark:border-rose-800/50 dark:text-rose-100",
    iconColor: "text-rose-600 dark:text-rose-400",
    jumlahPilihan: "4 Pilihan",
    ketentuan: "2 Program Akademik dan 2 Vokasi (Minimal ada 1 program D3).",
    alternatifs: [
      "2 Sarjana, 1 Diploma Tiga & 1 Diploma Empat/Sarjana Terapan",
      "2 Sarjana & 2 Diploma Tiga",
    ],
  },
];

export default function KetentuanProdi() {
  return (
    <div className="space-y-6 h-[70vh] overflow-auto">
      {/* Header Section */}
      <div className="flex flex-wrap items-center gap-3 mb-6 p-4 bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-800 rounded-xl transition-colors">
        <div className="p-2 bg-white dark:bg-slate-950 rounded-full shadow-sm border border-transparent dark:border-slate-800">
          <Info className="w-5 h-5 text-slate-600 dark:text-slate-400" />
        </div>
        <div>
          <h3 className="font-bold text-slate-800 dark:text-slate-200">
            Panduan Pemilihan Prodi
          </h3>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Perhatikan kombinasi program studi Akademik (Sarjana) dan Vokasi
            (D3/D4) yang diperbolehkan.
          </p>
        </div>
      </div>

      {/* Grid Layout Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4">
        {listKetentuan.map((item, index) => (
          <div
            key={index}
            // Pastikan item.color juga memiliki class dark, misal: "bg-blue-50 dark:bg-blue-900/20 text-blue-900 dark:text-blue-100"
            className={`relative flex flex-col h-full rounded-2xl border border-slate-200 dark:border-slate-800 p-5 transition-all hover:shadow-md ${item.color}`}
          >
            {/* Header Card */}
            <div className="mb-4">
              <span className="inline-block px-3 py-1 mb-2 text-xs font-bold uppercase tracking-wider bg-white/60 dark:bg-black/20 rounded-full border border-black/5 dark:border-white/10 dark:text-slate-300">
                Opsi {index + 1}
              </span>
              <h4 className="text-2xl font-bold tracking-tight mb-1 dark:text-slate-100">
                {item.jumlahPilihan}
              </h4>
              <p className="text-sm opacity-90 leading-relaxed min-h-[40px] dark:text-slate-300">
                {item.ketentuan}
              </p>
            </div>

            {/* Divider */}
            <div className="h-px bg-black/10 dark:bg-white/10 w-full mb-4" />

            {/* Content List */}
            <div className="flex-1">
              <p className="text-xs font-semibold uppercase opacity-70 mb-3 dark:text-slate-400">
                Kombinasi yang diizinkan:
              </p>
              <ul className="space-y-2.5">
                {item.alternatifs.map((value, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2.5 text-sm dark:text-slate-300"
                  >
                    <CheckCircle2
                      // Pastikan item.iconColor punya warna yang cocok di dark mode
                      className={`w-4 h-4 mt-0.5 shrink-0 ${item.iconColor}`}
                    />
                    <span className="leading-snug">{value}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
